// TODO: implement BaseFilter and BaseEdit

import BaseAdd from "./BaseAdd";
import BaseEdit from "./BaseEdit";
import BaseEntriesSummary from "./BaseEntriesSummary";
import BaseExport from "./BaseExport";
import BaseExportZip from "./BaseExportZip";
import BaseFilter from "./BaseFilter";
import BaseImport from "./BaseImport";
import BaseSearch from "./BaseSearch";
import CustomHeaderActions from "./CustomHeaderActions";
import React from "react";

export default function BaseTableSearchFilter({
  searchKey,
  exportData,
  exportZipData,
  addData,
  editTableData,
  importData,
  filterData,
  data,
  customHeaderActionsData,
}) {
  return (
    <div className="w-full font-light justify-between flex items-center">
      <div className="flex space-x-2 items-center">
        {searchKey && <BaseSearch searchKey={searchKey} />}
        {filterData && !!filterData.length && (
          <BaseFilter filterData={filterData} />
        )}
        {data && <BaseEntriesSummary data={data} />}
      </div>
      <div className="flex items-center space-x-2">
        {importData && <BaseImport data={importData} />}
        {exportData && <BaseExport exportData={exportData} />}
        {exportZipData && <BaseExportZip exportZipData={exportZipData} />}
        {editTableData && <BaseEdit editTableData={editTableData} />}
        {addData && <BaseAdd addData={addData} />}
        {customHeaderActionsData && <CustomHeaderActions actions={customHeaderActionsData} />}
      </div>
    </div>
  );
}
